import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { contentDate, reviewedIso } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import Link from 'next/link'
import { AirconServiceCostCalculator } from '../../../components/index/service-category/aircon-service/AirconServiceCostCalculator'
import { RequestProvider } from 'context/RequestContext'
import AirconRequestSection from '@/index/service-category/aircon-service/AirconRequestSection'
import { airconCostCalculation } from 'js/aircon-cost'
import { AnimatePresence } from 'framer-motion'
import { AirconScope } from '@/index/service-category/aircon-service/AirconScope'
import { useState } from 'react'
import AirconPricing from '@/index/service-category/aircon-service/AirconPricing'
import { AirconGeneralServiceProcess } from '@/index/service-category/aircon-service/AirconGeneralServiceProcess'
import ServiceWarranty from '@/index/service-category/aircon-service/ServiceWarranty'
import { buildAirconServiceGraph } from 'utils/aircon-page-schema'


// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-10-23'

export async function getStaticProps() {
    const countryCd = "sg"
    const countryName = "Singapore"
    
    const allRequestCategorySettings = await getRequestJSON(countryName)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Aircon Services")
    
    const lat = 1.3521
    const lng = 103.8198

    const { month, year } = contentDate(CONTENT_REVIEWED)
    const modifiedDate = reviewedIso(CONTENT_REVIEWED)
    const airconBlogs = blogsMaster['hvac-services'].blogArray
    
    const currencyCd = "SGD"
                
    let standardServicing = []
    let annualServicing = []
    let chemicalServicing = []
    let overhaulServicing = []    

    airconCostCalculation(currencyCd, annualServicing, standardServicing, chemicalServicing, overhaulServicing)

  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        airconBlogs,
        standardServicing,
        annualServicing,
        chemicalServicing,
        overhaulServicing,
        currencyCd,
        countryName
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}
export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const airconBlogs = props.airconBlogs
    const requestCategorySettings = props.requestCategorySettings;
    const standardServicing = props.standardServicing
    const annualServicing = props.annualServicing
    const chemicalServicing = props.chemicalServicing
    const overhaulServicing = props.overhaulServicing
    const brandName = "Samsung";
    const requestType = 'Aircon Services'
    const currencyCd = props.currencyCd
    const countryName = props.countryName

    const [ requestForm, setRequestForm ] = useState(false)
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const [ isCustomBook, setIsCustomBook ] = useState(false)
    
    const [ isShowJobScope, setIsShowJobScope ] = useState(false)
    const [ serviceType, setServiceType ] = useState("general")
    const [ unit, setUnit ] = useState("")
    const [ unitType, setUnitType ] = useState("")
    const [ cost, setCost ] = useState("")

  return (
    <>
      <Head>
        <title>Samsung Air Conditioner Servicing & Repair in Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="At StringsSG, our expertise lies in providing top-notch Samsung aircon servicing in Singapore. Our experienced technicians provide comprehensive maintenance and repair services for Samsung air conditioning units. Contact us for reliable and efficient servicing to ensure optimal performance of your aircon."/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/aircon-servicing-singapore/samsung" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Samsung Air Conditioner Servicing & Repair in Singapore`}/>
        <meta property="og:description" content="At StringsSG, our expertise lies in providing top-notch Samsung aircon servicing in Singapore. Our experienced technicians provide comprehensive maintenance and repair services for Samsung air conditioning units. Contact us for reliable and efficient servicing to ensure optimal performance of your aircon." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-09T09:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/living/samsung-air-conditioner.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/living/samsung-air-conditioner.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/aircon-servicing-singapore/samsung"/>
        <meta name="twitter:title" content={`Samsung Air Conditioner Servicing & Repair in Singapore`}/> 
        <meta name="twitter:description" content="At StringsSG, our expertise lies in providing top-notch Samsung aircon servicing in Singapore. Our experienced technicians provide comprehensive maintenance and repair services for Samsung air conditioning units. Contact us for reliable and efficient servicing to ensure optimal performance of your aircon."/>
        <link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(buildAirconServiceGraph({
            path: '/sg/aircon-servicing-singapore/samsung',
            pageName: 'Samsung Air Conditioner Servicing & Repair in Singapore',
            description: 'At StringsSG, our expertise lies in providing top-notch Samsung aircon servicing in Singapore. Our experienced technicians provide comprehensive maintenance and repair services for Samsung air conditioning units. Contact us for reliable and efficient servicing to ensure optimal performance of your aircon.',
            serviceName: 'Samsung Aircon Servicing & Repair Singapore',
            serviceType: 'Aircon Servicing',
            image: 'https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/living/samsung-air-conditioner.jpg',
            datePublished: '2025-01-09T09:30:46+00:00',
            modifiedDate,
            breadcrumbName: 'Samsung',
          })) }}
        />
        <link rel="canonical" href="https://www.stringssg.com/sg/aircon-servicing-singapore/samsung"/>
        </Head>
        <div>
            <RequestProvider>
                <AirconRequestSection
                    requestForm={requestForm}
                    setRequestForm={setRequestForm}
                    isQuickBook={isQuickBook}
                    setIsQuickBook={setIsQuickBook}
                    isCustomBook={isCustomBook}
                    setIsCustomBook={setIsCustomBook}
                    requestCategorySettings={requestCategorySettings}
                    standardServicing={standardServicing}
                    chemicalServicing={chemicalServicing}
                    overhaulServicing={overhaulServicing}
                    currencyCd={currencyCd}
                    countryName={countryName}
                    requestType={requestType}
                    setIsShowJobScope={setIsShowJobScope}
                    serviceType={serviceType}
                    setServiceType={setServiceType}
                    setUnit={setUnit}
                    setUnitType={setUnitType}
                    setCost={setCost}
                    heroImage="blog/living/samsung-air-conditioner.jpg"
                    title="Samsung Aircon Servicing Singapore"
                />
            </RequestProvider>
            <section className='max-w-5xl mx-auto py-10 px-2'>
                <header className='space-y-2 text-center '>
                    {/* H2: the hero above already renders this page's H1. */}
                    <h2 className='text-3xl md:text-4xl font-semibold'>Samsung Aircon Servicing & Repair in Singapore</h2>
                    <p className='leading-8'>
                    At StringsSG, our expertise lies in providing top-notch Samsung aircon servicing in Singapore. Our highly trained technicians are committed to delivering 
                    comprehensive maintenance and repair services for Samsung air conditioning units. We prioritize your satisfaction by offering reliable and efficient servicing 
                    that ensures your aircon system operates at its best. You can confidently reach out to us to initiate a request for our dependable and effective servicing 
                    solutions, guaranteeing optimal performance for your air conditioner.
                    </p>  
                </header>
                <div className='relative flex justify-center max-w-md mx-auto'>
                    <Image className='rounded-lg'
                            src={s3Static + "Samsung.png"}
                            height={150}
                            width={300}
                            style={{objectFit: 'contain', height:"auto", width:"auto"}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Samsung Aircon Servicing '
                    />          
                </div>
            </section>
            <AirconPricing
                standardServicing={standardServicing} 
                annualServicing={annualServicing} 
                chemicalServicing={chemicalServicing} 
                overhaulServicing={overhaulServicing} 
                gasTopup={[{type: 'R22', priceRange: 'S$40 - S$100'}, {type: 'R410A', priceRange: 'S$90 - S$150'}, {type: 'R32', priceRange: 'S$120 - S$220'}]}  
                currencyCd={currencyCd}
            />
            <section className='py-5 bg-slate-600'>
                <div className='max-w-2xl mx-auto text-center text-white py-5 space-y-4 px-2'>   
                    <h2 className='text-2xl font-bold'>Samsung Aircon Servicing Cost Calculator</h2>                
                    <p className='leading-7'>Use this calculator to get an estimation of how much you should be paying for Samsung Aircon Servicing in Singapore.</p>                       
                </div>
                <AirconServiceCostCalculator requestCategorySettings={requestCategorySettings}/>
            </section>
            <section className='max-w-5xl mx-auto py-10'>
                <AirconGeneralServiceProcess />
            </section> 
            <ServiceWarranty brand={brandName} />       
            <section className='max-w-5xl mx-auto py-10 px-2 space-y-3'>    
                <h2 className='text-2xl md:text-3xl text-center'>
                    <strong>Latest Samsung Aircon Models in Singapore</strong>
                </h2>
                <div className='space-y-5 leading-8'>   
                    <p>
                        StringsSG is dedicated to providing specialized servicing for a diverse range of Samsung air conditioning systems. Whether you possess a Samsung single split, 
                        Multi-Split system our team of skilled technicians is extensively trained to proficiently handle all varieties of Samsung air conditioning systems.                  
                    </p> 
                    <div className='relative h-96 w-full'>
                        <Image className='rounded-lg'
                                src={s3Static + "blog/living/samsung-air-conditioner.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'contain'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='Samsung New Aircon'
                        />          
                    </div>
                </div> 
            </section>
            <section className='max-w-5xl mx-auto my-10 space-y-5 text-center'>
                <h3 className='text-xl md:text-2xl font-bold uppercase text-amber-800'>New System Price Range</h3>
                <div className='py-2 px-2 space-y-2 max-w-5xl leading-8 mx-auto'> 
                    <p>
                        If you&apos;re contemplating the acquisition of a new Samsung air conditioning system, we provide competitive pricing options customized to your specific needs. 
                        The cost range for Samsung AC systems may fluctuate based on variables such as the model, capacity, features, and installation intricacy. Feel free to get in touch 
                        with us for a personalized quotation that aligns with your requirements.
                    </p> 
                </div>
            </section>
            <section className='max-w-5xl mx-auto my-5 space-y-5 text-center'>
                <h3 className='text-xl md:text-2xl font-bold uppercase text-amber-800'>Manufacturer Warranty Coverage</h3>
                <div className='space-y-2 p-2 leading-8'>
                    <p>
                        Each brand-new Samsung air conditioning system comes with a manufacturer&apos;s warranty, providing coverage for a designated period of time. The duration of the 
                        warranty may vary depending on the specific model and components of the system, typically ranging from 1 to 5 years. Our team is fully prepared to provide you 
                        with comprehensive information regarding the terms and conditions of the warranty that apply to your Samsung AC system.
                    </p>
                </div>    
            </section>
            <section className="py-10 px-4 max-w-5xl mx-auto space-y-6">
                <h2 className="text-center text-2xl md:text-3xl font-semibold uppercase text-gray-800">
                    Common Samsung Aircon Error Codes & Problems
                </h2>

                <article className="text-gray-700 text-base leading-relaxed space-y-4">
                    <p>
                    Samsung air conditioners, like all modern HVAC systems, may develop issues over time. Whether you&apos;re dealing with poor airflow or an error code on your unit&apos;s display, understanding the problem is the first step toward a fix. Below are some of the most frequently encountered Samsung aircon problems and corresponding error codes.
                    </p>

                    <h3 className="text-lg font-semibold text-gray-800 pt-4">Typical Samsung Aircon Problems:</h3>
                    <ul className="list-disc pl-5 space-y-1">
                    <li>Poor cooling or low airflow</li>
                    <li>Unusual noises or vibration</li>
                    <li>Water dripping or leakage</li>
                    <li>Sensor or PCB (control board) malfunction</li>
                    <li>Fan motor or compressor issues</li>
                    </ul>

                    <p>
                    Many Samsung aircon systems come equipped with diagnostic displays that show error codes. These codes help identify faults quickly and guide the repair process. Here’s a list of commonly reported Samsung aircon error codes:
                    </p>

                    <h3 className="text-lg font-semibold text-gray-800 pt-4">Samsung Air Conditioner Error Code Reference:</h3>
                    <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-slate-300 text-sm text-gray-700">
                        <thead className="bg-gray-100 text-orange-600">
                        <tr>
                            <th className="py-2 px-3 border border-slate-300 text-left">Error Code</th>
                            <th className="py-2 px-3 border border-slate-300 text-left">Description / Issue</th>
                        </tr>
                        </thead>
                        <tbody>
                        {[
                            { code: 'E101', desc: 'Communication error between indoor and outdoor unit' },
                            { code: 'E102', desc: 'Communication error between indoor unit and remote controller' },
                            { code: 'E201', desc: 'High-pressure switch open' },
                            { code: 'E202', desc: 'Low-pressure switch open' },
                            { code: 'E301', desc: 'Outdoor unit temperature sensor error' },
                            { code: 'E302', desc: 'Indoor unit temperature sensor error' },
                            { code: 'E401', desc: 'Fan motor error' },
                            { code: 'E402', desc: 'Indoor unit coil temperature sensor error' },
                            { code: 'E403', desc: 'Outdoor unit coil temperature sensor error' },
                            { code: 'E601', desc: 'Communication error with central controller' },
                        ].map(({ code, desc }) => (
                            <tr key={code} className="hover:bg-gray-50">
                            <td className="py-2 px-3 border border-slate-300 text-orange-600 font-semibold">{code}</td>
                            <td className="py-2 px-3 border border-slate-300">{desc}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    </div>

                    <p>
                    <strong>Important:</strong> Samsung aircon error codes may vary by model and series. If your unit shows one of these codes, our certified technicians can quickly identify and resolve the issue for reliable cooling comfort.
                    </p>
                </article>
            </section>
            <BlogsList blogs={airconBlogs}/>
        </div>
        {isShowJobScope &&
            <AnimatePresence>
                <AirconScope 
                setIsShowJobScope={setIsShowJobScope}
                serviceType={serviceType} 
                unit={unit} 
                unitType={unitType} 
                cost={cost} />
            </AnimatePresence>
        }
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}